export const users = {
  reset: {
    error:
      "Esta ação não pode ser realizada no momento. A conta do usuário alvo permanece inalterada. Por favor, tente novamente mais tarde. Se isso persistir, abra <a>um ticket de Problema de Conta</a> em nossa central de atendimento.",
    password: {
      action: "Redefinir senha",
      info: "Redefine a senha do Usuário enviando-lhe um e-mail com um link para redefinir sua senha. <br/><br/> Nota: esta ação não tem efeito se o usuário fizer login via SSO. <br/><br/> Consulte <docsLink>esta página em nossa documentação de ajuda</docsLink> para solução de problemas e correção de problemas de login.",
      warning:
        "Este link é <b>válido apenas por 1 hora</b>, portanto coordene um horário de recuperação com o usuário alvo de acordo. Se a janela de 1 hora for perdida, ele ficará bloqueado de sua conta até que esta ação de redefinição de senha seja executada novamente.",
    },
    mfa: {
      action: "Redefinir MFA",
      info: "Redefine o autenticador de múltiplos fatores do Usuário (Okta Verify, Google Authenticator ou ambos). Ele será solicitado a redefinir seu MFA novamente quando fizer login na próxima vez. <br/><br/> Consulte <docsLink>esta página em nossa documentação de ajuda</docsLink> para solução de problemas e correção de problemas de login.",
    },
  },
  deactivate: "Desativar",
  resend: "Reenviar",
  After_confirmation_this_invitation_will_be_deleted_and_user_lose_access:
    "Após a confirmação, este convite será excluído e o usuário perderá o acesso.",
  After_confirmation_this_person_will_be_deactivate_and_lose_access:
    "Após a confirmação, esta pessoa será desativada e perderá o acesso.",
  Are_you_sure_you_want_to_deactivate: "Tem certeza de que deseja desativar?",
  Are_you_sure_you_want_to_delete_invitation: "Tem certeza de que deseja excluir o convite?",
  Assign_roles: "Atribuir funções",
  Create_another_user: "Criar outro usuário",
  Edit_User: "Editar Usuário",
  Email: "E-mail",
  activate: "Ativar",
  First_Name: "Primeiro Nome",
  Here_you_will_manage_companys_users: "Aqui você gerenciará os usuários da empresa",
  Invite_New_User: "Convidar Novo Usuário",
  Invite_New_Users: "Convidar Novos Usuários",
  Job_Title: "Cargo",
  Roles: "Funções",
  Status: "Status",
  Surname: "Sobrenome",
  Update_user: "Atualizar usuário",
  Use_this_window_to_setup_a_new_user:
    "Use esta janela para convidar um novo usuário. Um usuário pode ter várias funções, exceto a função de 'Verificador'.",
  Users: "Usuários",
  users_management: "gerenciamento de usuários",
  no_users_added_yet: "Você ainda não adicionou nenhum usuário.",
  status_options: {
    invited: "Convidado",
    invitation_expired: "Convite expirado",
    active: "Ativo",
    deactivated: "Desativado",
  },
} as const;
